<div *ngIf="auth.featureFlags.showMenuRHS" class="menu-bside">
  <div class="cont" *ngIf="routing.isNewsletter()">
    <div class="cont" *ngIf="auth.featureFlags.showViewOptions">
      <div class="label" *ngIf="auth.featureFlags.showNewsletterLivePreview">
        View
      </div>
      <button
        mat-icon-button
        (click)="iLivePreview()"
        [class.active]="routing.isPreview()"
        matTooltip="Newsletter Live Preview"
        matTooltipPosition="left"
        *ngIf="auth.featureFlags.showNewsletterLivePreview"
      >
        <mat-icon>play_circle_outline</mat-icon>
      </button>
      <div class="space" *ngIf="auth.featureFlags.showNewsletterArticles"></div>
    </div>
  </div>

  <div class="cont" *ngIf="!routing.isHot() && !routing.isNewsletter()">
    <div
      *ngIf="
        auth.featureFlags.showViewOptions &&
        !(params.type === 'event' && params.id === 'super_event')
      "
      class="cont"
    >
      <div
        class="label"
        *ngIf="auth.featureFlags.showScannerView && routing.isFolio()"
      >
        Scan
      </div>
      <button
        mat-icon-button
        (click)="iScan()"
        [class.active]="routing.isScanner()"
        [class.light]="routing.theme === 'light'"
        matTooltip="Scanner"
        matTooltipPosition="left"
        *ngIf="auth.featureFlags.showScannerView && routing.isFolio()"
      >
        <mat-icon>compass_calibration</mat-icon>
      </button>
      <div
        class="space"
        *ngIf="auth.featureFlags.showScannerView && routing.isFolio()"
      ></div>
      <div
        class="label"
        *ngIf="auth.featureFlags.showMainView && routing.isQuery()"
      >
        Edit
      </div>
      <button
        mat-icon-button
        (click)="iMain()"
        [class.active]="routing.isMain()"
        [class.light]="routing.theme === 'light'"
        matTooltip="Main"
        matTooltipPosition="left"
        *ngIf="auth.featureFlags.showMainView && routing.isQuery()"
      >
        <mat-icon svgIcon="table-edit"></mat-icon>
      </button>
      <div
        class="space"
        *ngIf="auth.featureFlags.showMainView && routing.isQuery()"
      ></div>
      <div
        class="label"
        *ngIf="
          auth.featureFlags.showNewsView &&
          params.id !== 'default' &&
          params.type !== 'hierarchy' &&
          !routing.isQuery()
        "
      >
        News
      </div>
      <button
        mat-icon-button
        [class.active]="routing.isNewsaudit()"
        [class.light]="routing.theme === 'light'"
        (click)="iNewsaudit()"
        matTooltip="News View"
        matTooltipPosition="left"
        *ngIf="
          auth.featureFlags.showNewsView &&
          params.id !== 'default' &&
          params.type !== 'hierarchy' &&
          !routing.isQuery()
        "
      >
        <mat-icon>assignment</mat-icon>
      </button>
      <div
        class="space"
        *ngIf="
          auth.featureFlags.showNewsView &&
          params.id !== 'default' &&
          params.type !== 'hierarchy' &&
          !routing.isQuery()
        "
      ></div>
      <div
        class="label"
        *ngIf="
          (auth.featureFlags.showChart || auth.featureFlags.showBenchmark) &&
          params.id !== 'default' &&
          params.type !== 'hierarchy'
        "
      >
        Charts
      </div>
      <button
        mat-icon-button
        (click)="iChart()"
        [class.active]="routing.isChart()"
        [class.light]="routing.theme === 'light'"
        matTooltip="Chart"
        matTooltipPosition="left"
        *ngIf="
          auth.featureFlags.showChart &&
          params.id !== 'default' &&
          params.type !== 'hierarchy'
        "
      >
        <mat-icon>insert_chart</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="iChart2()"
        [class.active]="routing.isChart2()"
        [class.light]="routing.theme === 'light'"
        matTooltip="Benchmark"
        matTooltipPosition="left"
        *ngIf="
          auth.featureFlags.showBenchmark &&
          routing.isFolio() &&
          params.id !== 'default' &&
          !params.portfolioId
        "
      >
        <mat-icon>multiline_chart</mat-icon>
      </button>

      <div
        class="space"
        *ngIf="
          (auth.featureFlags.showChart || auth.featureFlags.showBenchmark) &&
          params.id !== 'default'
        "
      ></div>
    </div>
  </div>
</div>
